import {gql} from "@apollo/client";

export const GET_FORMS_OVERVIEW = gql`
	query GetFormSetups(
		$stage: String
		$first: Int
		$after: String
		$where: FormSetupFilterInput
		$order: [FormSetupSortInput!]
	)
	{
		formSetups(
			stage: $stage
			first: $first
			after: $after
			where: $where
			order: $order
		)
		{
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				formId
				formName
				frontEndName
				clientId
				versionId
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const GET_FORM_DETAILS = gql`
	query GetFormSetups(
		$stage: String
		$formName: String!
	)
	{
		formSetups(
			stage: $stage
			where: {
				formName: {
					eq: $formName
				}
			}
		)
		{
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				formId
				formName
				frontEndName
				clientId
				versionId
				remoteFormsNames
				questions {
					parameters
					extends
					definition
					frontEndName
					clientName
					name
					labelExpression
					label {
						isPresent
						value
					}
					subLabel {
						isPresent
						value
					}
					subLabelExpression
					description {
						isPresent
						value
					}
					valueType {
						isPresent
						value
					}
					queryType {
						isPresent
						value
					}
					valueOptions {
						isPresent
						value {
							value
							display
							extraDisplay
							extraDisplayExpression
						}
					}
					unit {
						isPresent
						value
					}
					defaultValue {
						isPresent
						value
					}
					mapping {
						isPresent
						value
					}
					defaultPositioning {
						isPresent
						value {
							afterQuestion
						}
					}
					missingRequiredValueErrorMessage {
						isPresent
						value
					}
					valueMapping
					defaultValueExpression
					visibleExpression
					enabledExpression
					editableExpression
					requiredExpression
					validators
					custom {
						postback
					}
				}
				layout
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const GET_FAKE_COMPOSED_FORM = gql`
	query FakeComposedForm(
		$stage: String
		$setups: [FormSetupInput!]!
		$formName: String!
		$frontEndName: String!
		$clientName: String!
		$clientVersion: Int
		$language: String
		$values: Any
	)
	{
		fakeComposedForm(
			stage: $stage
			setups: $setups
			formName: $formName
			frontEndName: $frontEndName
			clientName: $clientName
			clientVersion: $clientVersion
			language: $language
			values: $values
		)
		{
			versionedId
			versionHash
			questions {
				name
				label
				labelExpression
				description
				extraDisplay
				valueType
				queryType
				subLabel
				subLabelExpression
				valueOptions {
					value
					display
					extraDisplay
					extraDisplayExpression
				}
				valueMapping
				unit
				missingRequiredValueErrorMessage
				defaultValue
				defaultValueExpression
				visibleExpression
				enabledExpression
				editableExpression
				requiredExpression
				validators
				mapping
				defaultPositioning {
					afterQuestion
				}
				parameters
				value
				custom {
					postback
				}
				rendererProperties
			}
			layout {
				steps
			}
		}
	}
`;
